"use client";

import React, { useActionState, useEffect, useState } from "react";
import SectionLayout from "../ui/SectionLayout";
import { submitAssessmentForm } from "@/actions/assessment-form";
import ConfirmModal from "../ui/ConfirmModal";
import { ASSESSMENT_INITIAL_STATE } from "@/services/form.service";
import { SectionProps } from "./model";
import { getDefaultCmsSection } from "@/utils/helper";
import TextInput from "../ui/inputs/TextInput";
import DateInput from "../ui/inputs/DateInput";
import TextAreaInput from "../ui/inputs/TextAreaInput";
import FormLayout from "../ui/inputs/FormLayout";
import StoreSelect from "../ui/inputs/StoreSelect";

const AssessmentFormSectionComponent: React.FC<
  SectionProps<{
    app: any;
    title: string;
    description: string;
  }>
> = ({ app, cmsData, cmsSection }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [formState, formAction, isPending] = useActionState(
    submitAssessmentForm,
    ASSESSMENT_INITIAL_STATE
  );
  useEffect(() => {
    setIsOpen(formState.isSuccess ?? false);
  }, [formState]);
  const {
    firstName,
    lastName,
    address,
    zip,
    city,
    phone,
    email,
    message,
    time,
    date,
  } = formState?.data || {};

  cmsSection = {
    ...{
      ui: {
        padding: "lg",
        with: "xl",
      },
    },
    ...cmsSection,
  };
  return (
    <SectionLayout cmsSection={getDefaultCmsSection(cmsSection)}>
      <ConfirmModal
        app={app}
        description="Får du brug for at ændre, justere eller aflyse din bestilling, kan du kontakte os på:"
        title="Tak for din bestilling"
        setOpen={(isOpen) => setIsOpen(isOpen)}
        isOpen={isOpen}
      />
      <div className="flex flex-col gap-4 flex-1 w-full homepage-text-sm">
        <div className="homepage-text-xl" id="assessment-form">
          {cmsSection.specifics.title}
        </div>
        <div className="flex flex-col md:flex-row gap-4">
          <div className="md:w-1/3">
            {cmsSection.specifics.description && (
              <div
                className="styled-description homepage-text-sm"
                dangerouslySetInnerHTML={{
                  __html: `${cmsSection.specifics.description ?? ""}`,
                }}
              ></div>
            )}
          </div>
          <div className="flex flex-1 md:w-2/3">
            <FormLayout
              submitLabel="Bestil"
              isPending={isPending}
              formAction={formAction}
            >
              <StoreSelect
                cmsData={cmsData}
                label="Vælg butik"
                name="resourceGroupId"
                stores={app.stores}
              />
              <DateInput
                cmsData={cmsData}
                name="date"
                label="Dato"
                defaultValue={date}
                errors={formState?.zodErrors?.date}
                required={true}
              />
              <TextInput
                cmsData={cmsData}
                name="time"
                label="Ønsket tidspunkt på dagen"
                defaultValue={time}
                errors={formState?.zodErrors?.time}
                required={false}
              />
              <TextInput
                cmsData={cmsData}
                name="firstName"
                label="Fornavn"
                defaultValue={firstName}
                errors={formState?.zodErrors?.firstName}
                required={cmsData?.forms.nameRequired}
              />
              <TextInput
                cmsData={cmsData}
                name="lastName"
                label="Efternavn"
                defaultValue={lastName}
                errors={formState?.zodErrors?.lastName}
                required={cmsData?.forms.nameRequired}
              />
              <TextInput
                cmsData={cmsData}
                className="col-span-6"
                name="address"
                label="Adresse"
                defaultValue={address}
                errors={formState?.zodErrors?.address}
                required={cmsData?.forms.addressRequired}
              />
              <TextInput
                cmsData={cmsData}
                className="col-span-2"
                name="zip"
                label="Postnr"
                defaultValue={zip}
                errors={formState?.zodErrors?.zip}
                required={cmsData?.forms.zipRequired}
              />
              <TextInput
                cmsData={cmsData}
                className="col-span-4"
                name="city"
                label="By"
                defaultValue={city}
                errors={formState?.zodErrors?.city}
                required={cmsData?.forms.cityRequired}
              />
              <TextInput
                cmsData={cmsData}
                className="col-span-3"
                name="phone"
                label="Telefonnummer"
                defaultValue={phone}
                errors={formState?.zodErrors?.phone}
                required={cmsData?.forms.phoneRequired}
              />
              <TextInput
                cmsData={cmsData}
                className="col-span-3"
                name="email"
                label="E-mail"
                defaultValue={email}
                errors={formState?.zodErrors?.email}
                required={cmsData?.forms.emailRequired}
              />
              <TextAreaInput
                cmsData={cmsData}
                name="message"
                label="Besked"
                defaultValue={message}
                errors={formState?.zodErrors?.message}
                required={false}
              />
            </FormLayout>
          </div>
        </div>
      </div>
    </SectionLayout>
  );
};

export default AssessmentFormSectionComponent;
